import React from "react";
import { useQueryClient } from "react-query";

import api from "../../../api";
import ConfirmAction from "../../../components/modals/ConfirmAction";
import useFormatMessage from "../../../hooks/useFormatMessage";
import useFormatMultipleNames from "../../../hooks/useFormatMultipleNames";
import { Customer } from "../../../types/utilities";
import { getCustomerName } from "../../../utils/displayUtils";

interface ArchiveCustomersProps {
  customers: Customer[];
  onClose(): void;
  onSuccess(): void;
}

const ArchiveCustomers: React.FC<ArchiveCustomersProps> = (props) => {
  const { customers, onClose, onSuccess } = props;

  const queryClient = useQueryClient();
  const f = useFormatMessage();
  const formatMultipleNames = useFormatMultipleNames();

  const customerIds = customers.map((customer) => customer.id);
  const customersNamesLabel = formatMultipleNames(customers.map(getCustomerName));

  const archiveCustomersApiCall = () => api.archiveCustomers({ customer_ids: customerIds });

  const handleSuccess = async () => {
    await queryClient.invalidateQueries(["customers"]);
    onSuccess();
  };

  return (
    <ConfirmAction
      apiCall={archiveCustomersApiCall}
      onSuccess={handleSuccess}
      isOpen
      isDestructive
      title={f("bulk.actions.archive.confirmation.title")}
      description={f("bulk.actions.archive.confirmation.description", { names: customersNamesLabel })}
      onNo={onClose}
      actionTitle={f("bulk.actions.archive.label")}
      useSuccessToast
      successTitle={f("bulk.actions.archive.success.message", { count: customers.length })}
    />
  );
};

export default ArchiveCustomers;
